export default "__VITE_ASSET__B$qUGlB6__"